import { compose } from 'shared/utils/function.utils';
import { getCustomizationElementsReducer } from './get-customization-elements';

export const extraReducers = compose(getCustomizationElementsReducer);

export { getCustomizationElementsAction } from './get-customization-elements';
